import queryString from 'qs';
import React, { useContext, useEffect } from 'react';
// javascript plugin used to create scrollbars on windows
import { useLocation, useSearchParams } from 'react-router-dom';
import { AuthContext } from '../context/Auth';
import Loader from '../../assets/img/loading_transp.gif';
import WindowsHolder from '../windows/WindowsHolder';
import CookieConsentFelixMedicus from '../misc/CookieConsent';
import { TrackingContext } from '../context/Tracking';

const UrlMiddleware = props => {
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const [ready, setReady] = React.useState(false);
  const [params, setParams] = React.useState({});

  const { auth } = useContext(AuthContext);
  const { t, setSource } = React.useContext(TrackingContext);

  useEffect(() => {
    console.log(auth);
  }, [auth]);

  const search = (searchQuery) => {
    if (searchQuery === '?') {
      setParams({});
    } else {
      const parsedParams = searchQuery ? queryString.parse(searchQuery.replace('?', '')) : {};
      setParams(parsedParams);
    }
    setReady(true);
  };

  const changeParams = newParams => {
    setSearchParams({
      ...newParams// Object.keys(params).length > 0 ? '?' + queryString.stringify(params) : ''
    });
  };

  React.useEffect(() => {
    if (params.s) {
      t('website_hit', '', params.s);
      setSource(params.s)
      changeParams({});
    }
  }, [params]);

  React.useEffect(() => {
    search(location.search);
  }, [location.search]);

  const Child = props.child;

  return (
    <>
      {
        (ready && auth)
          ? (
            <WindowsHolder>
              <Child params={params} setParams={changeParams} />
              <CookieConsentFelixMedicus />
            </WindowsHolder>
            )
          : <center><img src={Loader} width={50} style={{ marginTop: window.innerHeight / 2 - 50 }} /></center>
      }
    </>
  );
};

export default UrlMiddleware;
